import useSWR from "swr"
import { Table } from "antd"

import { fetcher } from "../../../../api"
import { buildUsersTableColumns } from "./users-table-columns"

interface Props {
  tenantId: number
}

export const Users = ({ tenantId }: Props) => {
  const { data } = useSWR(`/users?tenantId=${tenantId}`, fetcher)

  const users = convertUsersToTableItems(data)
  
  return (
    <Table
      columns={buildUsersTableColumns()}
      dataSource={users}
      loading={!users}
      rowKey="id"
      size="small"
    />
  )
}

const convertUsersToTableItems = (users) => users?.map(({ firstName, surname, ...user }) => ({ name: `${firstName} ${surname}`, ...user }))